import VerticalSlider from "../../containers/VerticalSlider";

export const casinoGamesData = {
  indianCard: {
    CasinoMarinaAndarBahar: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-ott-andar-bahar",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/OttAndarBahar.jpg",
      alt: "casino marina andar bahar",
      name: "casino marina andar bahar",
      providerName: "Ezugi",
    },
    TeenPatti3Card: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-teen-patti",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/TeenPatti.jpg",
      alt: "teen patti 3 card",
      name: "teen patti 3 card",
      providerName: "Ezugi",
    },
    BetOnTeenPatti: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-bet-on-teen-patti",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/TeenPatti20-20.jpg",
      alt: "bet on teen patti",
      name: "bet on teen patti",
      providerName: "Ezugi",
    },
    AndarBahar: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-andar-bahar",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/AndarBahar.jpg",
      alt: "andar bahar",
      name: "andar bahar",
      providerName: "Ezugi",
    },
    // Cards32: {
    //   code: "",
    //   casino: "Ezugi",
    //   provider: "Ezugi",
    //   redirectUrl: "/casino/aggapezugi-32-cards",
    //   homeUrl: "/sports",
    //   imgUrl: "./images/casino-games/indian-card/32Cards.jpg",
    //   alt: "32 cards",
    //   name: "32 cards",
    //   providerName: "Ezugi",
    // },
    // SpanishRoulette: {
    //   code: "",
    //   casino: "Ezugi",
    //   provider: "Ezugi",
    //   redirectUrl: "/casino/ezg-spanish-roulette",
    //   homeUrl: "/sports",
    //   imgUrl: "./images/casino-games/indian-card/Roulette.jpg",
    //   alt: "spanish roulette",
    //   name: "spanish roulette",
    //   providerName: "Ezugi",
    // },
    CricketWar: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-cricket-war",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/Cricketwar.jpg",
      alt: "cricket war",
      name: "cricket war",
      providerName: "Ezugi",
    },
    SicBo: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-sic-bo",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/Sicbo.jpg",
      alt: "sic bo",
      name: "sic bo",
      providerName: "Ezugi",
    },
    Baccarat: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-baccarat",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/Baccarat.jpg",
      alt: "baccarat",
      name: "baccarat",
      providerName: "Ezugi",
    },
    DragonTiger: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-dragon-tiger",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/DragonTiger.jpg",
      alt: "dragon tiger",
      name: "dragon tiger",
      providerName: "Ezugi",
    },
    OneDayTteenPatti: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-one-day-teen-patti-classic",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/OneDayTeenPatti.jpg",
      alt: "one day teen patti",
      name: "one day teen patti",
      providerName: "Ezugi",
    },
    UltimateRoulette: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-ultimate-roulette",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/UltimateRoulette.jpg",
      alt: "UltimateRoulette",
      name: "Ultimate Roulette",
      providerName: "Ezugi",
    },
  },

  popularGames: {
    MarbelRaceMonaco: {
      redirectUrl: "/casino/aggapezugi-ez-marble-race-monaco",
      code: "100",
      casino: "ezugi",
      provider: "",
      homeUrl: "",
      imgUrl: "./images/casino-games/popular/ezmarbleracemonaco.webp",
      alt: "Marbel Race Monaco",
      name: "Marbel Race Monaco",
    },
    //  BetwithStreamers: {
    //     redirectUrl:  "/casino/aggapezugi-bet-with-streamers",
    //     code: "100",
    //     casino: "ezugi",
    //     provider: "",
    //     homeUrl: "",
    //     imgUrl: "./images/casino-games/popular/betwithstreamers.webp",
    //     alt: "Bet with Streamers",
    //     name: "Bet with Streamers",
    //   },
    // AndarAaharVivo: {
    //   code: "",
    //   casino: "Ezugi",
    //   provider: "Ezugi",
    //   redirectUrl: "/casino/vivo-andar-bahar",
    //   homeUrl: "/sports",
    //   imgUrl: "./images/casino-games/popular/vivoAndarBahar.jpg",
    //   alt: "andar bahar",
    //   name: "andar bahar",
    //   providerName: "Ezugi",
    // },
    // TeenPattiVivo: {
    //   code: "",
    //   casino: "Ezugi",
    //   provider: "Ezugi",
    //   redirectUrl: "/casino/vivo-teen-patti",
    //   homeUrl: "/sports",
    //   imgUrl: "./images/casino-games/popular/vivoTeenPatti.jpg",
    //   alt: "teen patti",
    //   name: "teen patti",
    //   providerName: "Ezugi",
    // },
    // DragonTigerVivo: {
    //   code: "",
    //   casino: "Ezugi",
    //   provider: "Ezugi",
    //   redirectUrl: "/casino/vivo-dragon-tiger",
    //   homeUrl: "/sports",
    //   imgUrl: "./images/casino-games/popular/vivo-dragon-tiger.jpg",
    //   alt: "dragon tiger",
    //   name: "dragon tiger",
    //   providerName: "Ezugi",
    // },
    // LasVegasBlackjackVivo: {
    //   code: "",
    //   casino: "Ezugi",
    //   provider: "Ezugi",
    //   redirectUrl: "/casino/vivo-las-vegas-blackjack",
    //   homeUrl: "/sports",
    //   imgUrl: "./images/casino-games/popular/vivo-las-vegas-blackjack.jpg",
    //   alt: "las vegas blackjack",
    //   name: "las vegas blackjack",
    //   providerName: "Ezugi",
    // },
    // LimitlessBlackjackVivo: {
    //   code: "",
    //   casino: "Ezugi",
    //   provider: "Ezugi",
    //   redirectUrl: "/casino/vivo-las-vegas-roulette",
    //   homeUrl: "/sports",
    //   imgUrl: "./images/casino-games/popular/vivo-las-vegas-roulette.jpg",
    //   alt: "limitless blackjack",
    //   name: "limitless blackjack",
    //   providerName: "Ezugi",
    // },
    // MacauBaccaratVivo: {
    //   code: "",
    //   casino: "Ezugi",
    //   provider: "Ezugi",
    //   redirectUrl: "/casino/vivo-macau-baccarat",
    //   homeUrl: "/sports",
    //   imgUrl: "./images/casino-games/popular/vivo-macau-baccarat.jpg",
    //   alt: "macau baccarat",
    //   name: "macau baccarat",
    //   providerName: "Ezugi",
    // },
    Lucky7: {
      code: "228000",
      casino: "ezugi",
      provider: "",
      redirectUrl: "/casino/aggapezugi-lucky-7",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/indian-card/Lucky7.jpg",
      alt: "Lucky 7",
      name: "Lucky 7",
      providerName: "Ezugi",
    },
    AutoRoulette: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-automatic-roulette",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/Auto-Roulette.jpg",
      alt: "auto roulette",
      name: "auto roulette",
      providerName: "Ezugi",
    },
    BbetOnTeenPatti: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-bet-on-teen-patti",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/BetOnTeenPatti.jpg",
      alt: "bet on teen patti",
      name: "bet on teen patti",
      providerName: "Ezugi",
    },
    AndarBahar: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-andar-bahar",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/AndarBahar.jpg",
      alt: "andar bahar",
      name: "andar bahar",
      providerName: "Ezugi",
    },
    Baccarat: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-baccarat",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/Baccarat.jpg",
      alt: "baccarat",
      name: "baccarat",
      providerName: "Ezugi",
    },
    FirstPersonMegaBall: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/ezgevo-first-person-mega-ball",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/popular/MegaBall.jpg",
      alt: "ezgevo first person mega ball",
      name: "ezgevo first person mega ball",
      providerName: "Ezugi",
    },
  },

  anvioGames: {
    Zhandu: {
      name: "Zhandu",
      providerName: "Anvio",
      imgUrl: "./images/anvio-games/Zhandu.webp",
      redirectUrl: "/casino/anvioanvio-zhandu",
    },
    Teenpatti: {
      name: "Teenpatti",
      providerName: "Anvio",
      imgUrl: "./images/anvio-games/teenpatti.webp",
      redirectUrl: "/casino/anvioanvio-teenpatti",
    },
    DragonTiger: {
      name: "Dragon Tiger",
      providerName: "Anvio",
      imgUrl: "./images/anvio-games/dragontiger.webp",
      redirectUrl: "/casino/anvioanvio-dragon-tiger",
    },
    Dana: {
      name: "Dana",
      providerName: "Anvio",
      imgUrl: "./images/anvio-games/dana.webp",
      redirectUrl: "/casino/anvioanvio-dana",
    },
    Roulette: {
      name: "Roulette",
      providerName: "Anvio",
      imgUrl: "./images/anvio-games/Roulette.webp",
      redirectUrl: "/casino/anvioanvio-roulette",
    },
    SevenUpAndDown: {
      name: "7 Up & Down",
      providerName: "Anvio",
      imgUrl: "./images/anvio-games/sevenupdown.webp",
      redirectUrl: "/casino/anvioanvio-7-up-and-down",
    },
    Teenpatti2: {
      name: "Teenpatti 2",
      providerName: "Anvio",
      imgUrl: "./images/anvio-games/Teenpatti2.webp",
      redirectUrl: "/casino/anvioanvio-teenpatti2",
    },
  },

  rightBarGames: {
    BaccaratRB: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-baccarat",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/baccarat.jpg",
      alt: "baccarat",
      name: "baccarat",
      providerName: "Ezugi",
    },
    // OracleBlazeRouletteRB: {
    //   code: "",
    //   casino: "Vivo",
    //   provider: "Vivo",
    //   redirectUrl: "/casino/vivo-oracle-blaze-roulette",
    //   homeUrl: "/sports",
    //   imgUrl: "./images/casino-games/rightbar/vivo-oracle-blaze-roulette.jpg",
    //   alt: "oracle blaze roulette",
    //   name: "oracle blaze roulette",
    //   providerName: "Vivo",
    // },
    SicBoRB: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-sic-bo",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/sic-bo.jpg",
      alt: "sic bo",
      name: "sic bo",
      providerName: "Ezugi",
    },
    SpeedRouletteRB: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-speed-roulette",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/speed-roulette.jpg",
      alt: "speed roulette",
      name: "speed roulette",
      providerName: "Ezugi",
    },
    BlackJackRB: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-unlimited-blackjack",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/blackJack.jpg",
      alt: "Blackjack",
      name: "Blackjack",
      providerName: "Ezugi",
    },
    ItalianRouletteRB: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-italian-roulette",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/italian-roulette.jpg",
      alt: "italian roulette",
      name: "italian roulette",
      providerName: "Ezugi",
    },
    NamasteRouletteRB: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-namaste-roulette",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/namaste-roulette.jpg",
      alt: "namaste roulette",
      name: "namaste roulette",
      providerName: "Ezugi",
    },
    Lucky7RB: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-lucky-7",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/lucky7.jpg",
      alt: "lucky 7",
      name: "lucky 7",
      providerName: "Ezugi",
    },
    // Cards32RB: {
    //   code: "",
    //   casino: "Ezugi",
    //   provider: "Ezugi",
    //   redirectUrl: "/casino/aggapezugi-32-cards",
    //   homeUrl: "/sports",
    //   imgUrl: "./images/casino-games/rightbar/cards32.jpg",
    //   alt: "32 cards",
    //   name: "32 cards",
    //   providerName: "Ezugi",
    // },
    AndarBaharRB: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-andar-bahar",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/rightbar/andar-bahar.jpg",
      alt: "andar bahar",
      name: "andar bahar",
      providerName: "Ezugi",
    },
  },

  verticalSlider: {
    AviatorVS: {
      code: "",
      casino: "Spribe",
      provider: "Spribe",
      redirectUrl: "/casino/aggapspribe-aviator",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/VSlider/aviator.jpg",
      alt: "aviator",
      name: "aviator",
      providerName: "Spribe",
    },
    OneDayTeenPattiVS: {
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      redirectUrl: "/casino/aggapezugi-one-day-teen-patti-classic",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/VSlider/one-day-teen-patti.jpg",
      alt: "one day teen patti",
      name: "one day teen patti",
      providerName: "Ezugi",
    },
    SpeedVipBlackjackAVS: {
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      redirectUrl: "/casino/ezgevo-speed-vip-blackjack-a",
      homeUrl: "/sports",
      imgUrl: "./images/casino-games/VSlider/speed-vip-blackjack-a.jpg",
      alt: "speed vip blackjack a",
      name: "speed vip blackjack a",
      providerName: "Ezugi",
    },
  },
};
